import Raven from 'raven-js';
import get from 'lodash/get';
import isError from 'lodash/isError';
import { isLocalEnv, isPullRequestEnv } from 'src/common/utils/environment';

function safeStringify(obj) {
  try {
    const string = JSON.stringify(obj);
    return { string };
  } catch (error) {
    return { error };
  }
}

export default function captureReduxError(err, store, action) {
  if (isLocalEnv() || isPullRequestEnv()) {
    if (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }

    return;
  }

  if (err) {
    const extra = {
      redux: true,
      action,
    };

    if (!isError(err)) {
      const { string: dump, error: dumpError } = safeStringify(err);

      extra.isNotError = true;
      if (dump) extra.dump = dump;
      if (dumpError) extra.dumpError = dumpError;
    }

    Raven.captureException(err, { extra });
  } else {
    Raven.captureBreadcrumb({
      category: 'redux',
      message: get(action, 'type'),
    });
  }
}
